var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.293 1.273a.995.995 0 0 0 0 1.41l3.293 3.285L.293 9.252a.995.995 0 0 0 0 1.41c.39.39 1.024.39 1.414 0L5 7.378l3.293 3.284c.39.39 1.024.39 1.414 0a.995.995 0 0 0 0-1.41L6.414 5.968l3.293-3.284a.995.995 0 0 0 0-1.41 1.002 1.002 0 0 0-1.414 0L5 4.556 1.707 1.273a1.002 1.002 0 0 0-1.414 0Z",
    fill: "#5C7783"
  })));
};
export default SvgIconClose;